import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleGetDocumentsToDispatchKsefGridQuery, SaleGetDocumentsToDispatchKsefGridQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleGetDocumentsToDispatchKsefGridQuery)
@Wrapper(SaleGetDocumentsToDispatchKsefGridQueryHandlerBase)
export class SaleGetDocumentsToDispatchKsefGridQueryHandler {
    public constructor(
        http: Http
    ) { }
}
